<template>
    <div class="lp-category-details">
        <div class="row lp-category-details">
            <div class="col-12 description-wrapper">
                <div class="description">
                    <design-2021-apprentice-display-html-component :html-content="lpCategoryIn.description">
                    </design-2021-apprentice-display-html-component>
                </div>
            </div>
            <!--            <div class="col-12 col-md-6 col-xl-6 offset-xl-1 media-wrapper">-->
            <!--                <div class="gallery">-->
            <!--                    <design-2021-learning-path-category-show-gallery-slider-component :gallery-in="gallery">-->
            <!--                    </design-2021-learning-path-category-show-gallery-slider-component>-->
            <!--                </div>-->
            <!--            </div>-->
        </div>

        <div class="lp-category-assignments">
            <h3 class="title">{{ $t('learning_path.exercises') }}n</h3>

            <div class="row">
                <div
                    class="col-12 col-md-6 col-xl-3 d-flex flex-column"
                    v-for="lpAssignment of lpAssignments"
                    :key="lpAssignment.id">
                    <design-2021-learning-path-assignment-card-component
                        :lp-assignment-in="lpAssignment"
                        @open-modal="showAssignmentModal($event)">
                    </design-2021-learning-path-assignment-card-component>
                </div>
            </div>
        </div>

        <design-2021-learning-path-detail-assignment-modal-component
            ref="lp-assignment-modal"></design-2021-learning-path-detail-assignment-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-learning-path-category-component',
    props: ['lpCategoryIn', 'lpDeadlineIdIn'],
    data() {
        return {
            lpAssignments: this.lpCategoryIn.lp_assignments,
            gallery: [
                {
                    id: 12,
                    title: this.$t('learning_path.newspaper_headlines'),
                    path: 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
                },
                {
                    id: 45,
                    title: this.$t('learning_path.meeting'),
                    path: 'https://images.unsplash.com/photo-1557804506-e969d7b32a4b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1145&q=80',
                },
                {
                    id: 27,
                    title: 'Fake news',
                    path: 'https://images.unsplash.com/photo-1636188540036-1879f679c2b0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1761&q=80',
                },
                {
                    id: 150,
                    title: 'News',
                    path: 'https://images.unsplash.com/photo-1584713503693-bb386ec95cf2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80',
                },
                {
                    id: 5,
                    title: 'News coverage',
                    path: 'https://images.unsplash.com/photo-1581092787765-e3feb951d987?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
                },
                {
                    id: 33,
                    title: 'Camera setup',
                    path: 'https://images.unsplash.com/photo-1497015289639-54688650d173?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=80',
                },
                {
                    id: 10,
                    title: 'Interview',
                    path: 'https://images.unsplash.com/photo-1554200876-907f9286c2a1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
                },
            ],
        };
    },
    methods: {
        showAssignmentModal(lpAssignment) {
            this.$refs['lp-assignment-modal'].show(lpAssignment, this.lpDeadlineIdIn);
        },
    },
};
</script>

<style scoped lang="scss">
.lp-category-details {
    margin-bottom: map-get($grid-gutter-spacing, 'sixty');

    .description {
        font-size: $base-font-size;
        line-height: 1.5;
    }

    .media {
        height: 325px;
        margin-bottom: $grid-gutter-width;

        img {
            height: 100%;
            width: 100%;
            object-fit: cover;
            object-position: center;
        }
    }
}

.lp-category-assignments {
    .title {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }
}
</style>
